/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Search from 'flarum/forum/components/Search';

/**
 * The protected `Search` internals this override reaches into.
 */
interface SearchInternals {
	searchTimeout?: number;
	loadingSources: number;
}

export default function disableEnterSearch(): void {
	override(Search.prototype, 'selectResult', function (this: Search) {
		// Body copied from core's Search.selectResult, apart from the branch below.

		const internals = this as unknown as SearchInternals;

		clearTimeout(internals.searchTimeout);
		internals.loadingSources = 0;

		if (this.state.getValue()) {
			// The change: go to the articles page instead of the highlighted result.
			m.route.set(app.route.of_articles(this.state.getValue().toLowerCase()));
		} else {
			this.clear();
		}

		this.$('input').blur();
	});

	// TODO: let the user pick a search result with the arrow keys.
}
